import React from 'react';
import { Link, useParams, Navigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import Layout from '../../components/Layout';
import LandingNavbar from '../../components/LandingNavbar';
import LandingFooter from '../../components/LandingFooter';
import { getCategoryById, getArticlesByCategory, HELP_CATEGORIES } from '../../data/helpArticles';
import './Help.css';

/**
 * Help Category Page
 * Shows all articles within a specific category
 * Logged in: uses app Layout | Not logged in: uses LandingNavbar/Footer
 * URL: /help/:category
 */
const HelpCategory = () => {
  const { category } = useParams();
  const { isAuthenticated } = useAuth();
  const categoryData = getCategoryById(category);
  const articles = getArticlesByCategory(category);

  // Redirect to help home if category not found
  if (!categoryData) {
    return <Navigate to="/help" replace />;
  }

  const content = (
    <div className="help-container">
      {/* Breadcrumb Navigation */}
      <nav className="help-breadcrumb">
        <Link to="/help">Help Center</Link>
        <span className="help-breadcrumb-separator">/</span>
        <span className="help-breadcrumb-current">{categoryData.name}</span>
      </nav>

      <div className="help-header">
        <span className="help-category-icon-large">{categoryData.icon}</span>
        <h1>{categoryData.name}</h1>
        <p className="help-subtitle">{categoryData.description}</p>
      </div>

      {articles.length > 0 ? (
        <div className="help-articles-list">
          {articles.map((article) => (
            <Link
              key={article.slug}
              to={`/help/${category}/${article.slug}`}
              className="help-article-card"
            >
              <h3 className="help-article-title">{article.title}</h3>
              {article.summary && (
                <p className="help-article-summary">{article.summary}</p>
              )}
              <span className="help-article-read-more">Padhein →</span>
            </Link>
          ))}
        </div>
      ) : (
        <div className="help-empty-state">
          <p>Is category mein abhi koi article nahi hai.</p>
          <p>Jaldi hi add hoga!</p>
        </div>
      )}

      {/* Category Navigation */}
      <div className="help-other-categories">
        <h3>Aur categories dekhein</h3>
        <div className="help-category-links">
          {HELP_CATEGORIES.filter(cat => cat.id !== category).map((cat) => (
            <Link key={cat.id} to={`/help/${cat.id}`} className="help-category-link">
              {cat.icon} {cat.name}
            </Link>
          ))}
        </div>
      </div>
    </div>
  );

  if (isAuthenticated) {
    return <Layout>{content}</Layout>;
  }

  return (
    <>
      <LandingNavbar />
      {content}
      <LandingFooter />
    </>
  );
};

export default HelpCategory;
